import CrossIcon from "@/assets/icons/cross.svg?react";
import FileIcon from "@/assets/icons/file.svg?react";
import { Typography } from "@/components/ui/typography";
import { cn } from "@/lib/utils";

type AttachedDocumentProps = {
  onDelete?: () => void;
  document: { name: string | null; size: number | string; link?: any; type: string };
  onClick?: () => void;
};
export default function AttachedDocument({ onDelete, document, onClick }: AttachedDocumentProps) {
  const size = typeof document.size === "number" ? `${document.size / 1000} KB` : document.size;
  const type = document.type.includes("/") ? document.type.split("/")[1] : document.type;

  return (
    <div onClick={onClick} className={cn("schedule flex gap-3 rounded-lg px-6 py-4", onClick && "cursor-pointer")}>
      <div className="relative">
        <FileIcon />
        <div className="absolute left-[-6px] top-4 bg-error-500 p-1 text-[10px] font-bold uppercase text-white">
          {type.slice(0, 3)}
        </div>
      </div>
      <div>
        <Typography variant="text-small" className="text-gray-900" weight="medium">
          {document.name}
        </Typography>
        <Typography variant="text-small" className="text-gray-700" weight="regular">
          {size}
        </Typography>
      </div>
      {onDelete && (
        <CrossIcon
          className="cursor-pointer text-gray-500"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onDelete();
          }}
        />
      )}
    </div>
  );
}
